/* eslint-disable quote-props */
/* eslint-disable react/state-in-constructor */
import { Flex } from 'antd';
import Tag from 'Components/Tag/Tag';
import moment from 'moment';
import { func, shape } from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { healthSummaryRetrieve } from 'Redux/modules/webChat/actions';
import { getHealthSummaryById } from 'Selectors/webChat/healthSummary';
import { Accordion, Icon, List } from 'semantic-ui-react';

import useCalcualatorAIScore from '../../FinishConsult/hooks/useCalcualatorAIScore';

import { HISTORY_DETAILS, HISTORY_SUMMARY } from './ContentType';

const DATE_FORMAT = 'YYYY/M/D';

const ConsultItem = props => {
  const [active, setActive] = useState(false);
  const { consult, goToMenu } = props;

  const goToConsultDetails = () => {
    goToMenu(consult, HISTORY_DETAILS);
  };

  const goToConsultSummary = () => {
    goToMenu(consult, HISTORY_SUMMARY);
  };

  const { healthSummary: listHealthSummary, createdAt, endedAt } = consult ?? { healthSummary: [] };
  const strEndedAt = endedAt
    ? moment.utc(endedAt).local().format(DATE_FORMAT)
    : moment().format(DATE_FORMAT);

  const fromTime = moment.utc(createdAt).local().format(DATE_FORMAT);

  const dispatch = useDispatch();

  const { healthSummaryId, doctorId } = listHealthSummary[0] || {};

  const healthSummary = useSelector(
    state => getHealthSummaryById(state, healthSummaryId),
    shallowEqual,
  );

  const getHealthSummary = useCallback(async () => {
    await dispatch(healthSummaryRetrieve({ summaryId: healthSummaryId, doctorId })); // NOSONAR
  }, [dispatch, healthSummaryId, doctorId]);

  useEffect(() => {
    if (healthSummaryId && doctorId && !healthSummary) {
      getHealthSummary();
    }
  }, [healthSummary, doctorId, healthSummaryId, getHealthSummary]);

  const onClickCollapse = () => {
    setActive(!active);
    if (healthSummaryId && doctorId && !healthSummary) {
      getHealthSummary();
    }
  };

  const evaluation = healthSummary?.evaluation;

  const { scoreLabel, color } = useCalcualatorAIScore(evaluation?.score);

  const {
    data: { enableAiChecker },
  } = useSelector(state => state.webChat.doctor);

  return (
    <Accordion fluid>
      <Accordion.Title active={active} onClick={onClickCollapse}>
        {`From  ${fromTime}  to  ${strEndedAt}`}
        <Icon name="dropdown" style={{ float: 'right' }} />
      </Accordion.Title>
      <Accordion.Content active={active}>
        <List relaxed>
          <List.Item>
            <List.Icon name="info circle" />
            <List.Content as="a" onClick={goToConsultDetails}>
              <List.Description>View Consultation Details</List.Description>
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Icon name="file text" />
            <List.Content as="a" onClick={goToConsultSummary}>
              <List.Description>
                <Flex gap={8} alignItems="flex-start">
                  <div>View Consult Summary</div>
                  {scoreLabel && enableAiChecker && (
                    <Tag style={{ borderRadius: 100 }} color={color}>
                      {scoreLabel}
                    </Tag>
                  )}
                </Flex>
              </List.Description>
            </List.Content>
          </List.Item>
        </List>
      </Accordion.Content>
    </Accordion>
  );
};

ConsultItem.propTypes = {
  goToMenu: func.isRequired,
  consult: shape({}).isRequired,
};

ConsultItem.defaultProps = {};

export default ConsultItem;
